import { useUserSettings } from '@/api/userSettings';

/**
 * Whether sales-mode framing (ICP/offering, outreach-as-sales, conversion
 * metrics) is enabled for this user. New users default to the personal-CRM
 * experience (false); existing users are backfilled to true. Returns
 * `undefined` while settings load so callers can avoid flashing the wrong
 * framing on first paint.
 */
export function useSalesFeatures(): boolean | undefined {
  const { data, isLoading } = useUserSettings();
  if (isLoading || !data) return undefined;
  return data.salesFeaturesEnabled;
}
